import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Paper, Typography, TextField, Button, Alert, CircularProgress } from '@mui/material';
import { HeaderV2, FooterV2 } from '../../components/layout';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { getApiErrorMessage, PASSWORD_HINT } from '../../utils/authErrors';
import { API_BASE_URL } from '../../config/api';
import { persistSession } from '../../store/slices/authSlice';

const RegisterPageV2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '', confirmPassword: '', phone: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/register`, {
        email: form.email.trim(),
        password: form.password,
        confirmPassword: form.confirmPassword,
        phone: form.phone?.trim() || undefined,
        phoneCountryCode: form.phone ? '+92' : undefined,
      });
      const accessToken = response.data.accessToken || response.data.token;
      const user = response.data.user;
      if (accessToken) {
        dispatch(
          persistSession({
            accessToken,
            refreshToken: response.data.refreshToken,
            user: user || { email: form.email.trim(), name: form.name },
          })
        );
        navigate('/v2/dashboard');
      } else {
        navigate('/v2/login', { state: { message: 'Account created. Please sign in.' } });
      }
    } catch (err) {
      setError(getApiErrorMessage(err, 'Registration failed. Please try again.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ backgroundColor: 'background.default', minHeight: '100vh' }}>
      <HeaderV2 />
      <Container maxWidth="sm" sx={{ py: 6 }}>
        <Paper sx={{ p: 4 }} component="form" onSubmit={handleSubmit}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>Create account</Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TextField label="Full Name" name="name" fullWidth sx={{ mb: 2 }} value={form.name} onChange={handleChange} helperText="Optional — for your profile later" />
          <TextField label="Email" name="email" type="email" required fullWidth sx={{ mb: 2 }} value={form.email} onChange={handleChange} />
          <TextField label="Phone" name="phone" fullWidth sx={{ mb: 2 }} value={form.phone} onChange={handleChange} placeholder="03001234567" />
          <TextField label="Password" type="password" name="password" required fullWidth sx={{ mb: 2 }} value={form.password} onChange={handleChange} helperText={PASSWORD_HINT} />
          <TextField label="Confirm password" type="password" name="confirmPassword" required fullWidth sx={{ mb: 2 }} value={form.confirmPassword} onChange={handleChange} />
          <Button type="submit" variant="contained" fullWidth disabled={loading}>
            {loading ? <CircularProgress size={24} /> : 'Register'}
          </Button>
          <Button onClick={() => navigate('/v2/login')} sx={{ mt: 1 }} fullWidth variant="text">
            Already have an account? Login
          </Button>
        </Paper>
      </Container>
      <FooterV2 />
    </Box>
  );
};

export default RegisterPageV2;
